import { getArrayDefault } from 'src/utils/helpers/arrayHelpers';

export function setCookie(name: string, value: string, days: number) {
  const expires = new Date(Date.now() + days * 864e5).toUTCString();
  const domain = window.location.hostname;

  document.cookie = `${name}=${encodeURIComponent(
    value,
  )}; expires=${expires}; path=/; domain=.${domain}; samesite=none; secure`;
}

export function getCookie(name: string) {
  const value = `; ${document.cookie}`;
  const parts = getArrayDefault(value.split(`; ${name}=`));
  if (parts.length === 2) return (parts.pop() || '').split(';').shift();
}

export function deleteCookie(name: string) {
  const domain = window.location.hostname;
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=.${domain}; samesite=none; secure`;
}
